<ng-container *ngIf="!!(currentUser$ | async)">
  <button (click)="openPlaylistDialog(song.id, $event)" class="btn btn-sm btn-primary rounded-circle">
    <i class="bi bi-plus mr-1"></i>
  </button>
</ng-container>
